import { toSignal } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';

import { some, values } from 'lodash-es';
import { map, startWith } from 'rxjs';

import { NetSheetFormFieldSettings } from '../typings/net-sheet';

export function checkFormValidity(form: FormGroup) {
  return toSignal(
    form.statusChanges.pipe(
      startWith(form.status),
      map(() => form.valid)
    ),
    {
      initialValue: form.valid
    }
  );
}

export function showComponentByFieldsVisibility(fieldsData: { [key: string]: NetSheetFormFieldSettings }) {
  return some(values(fieldsData), (field) => field.visible);
}
